// 应用配置文件
const config = {
  // WebSocket连接配置
  ws: {
    host: process.env.VUE_APP_WS_HOST || '',
    port: process.env.VUE_APP_WS_PORT || '',
    protocol: process.env.VUE_APP_WS_PROTOCOL || 'ws'
  },

  // API配置
  api: {
    baseURL: process.env.VUE_APP_API_BASE_URL || ''
  },

  getWsUrl (token) {
    const { protocol, host, port } = this.ws
    if (host && port) {
      return `${protocol}://${host}:${port}/room/ws/?token=${token}`
    }
    const wsProtocol = window.location.protocol === 'https:' ? 'wss:' : 'ws:'
    return `${wsProtocol}//${window.location.host}/room/ws/?token=${token}`
  },

  getApiUrl (path = '') {
    const baseURL = this.api.baseURL
    if (baseURL) {
      return `${baseURL}${path}`
    }
    return `/api${path}`
  }
}

export default config
